import React, { useEffect } from 'react';
import styled from 'styled-components';
export const ControlsWrapper = styled.div `
  background: #fefefe;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: ${({ controlNums }) => controlNums ? `repeat(${controlNums.length}, 1fr)` : '5'};
  grid-gap: 8px;
  border-top: 1px solid #dfdfdf;
  padding: 8px 16px;
  z-index: 100;
  height: 100px;
  align-items: center;
`;
const ActionButtonWrapper = styled.div `
  background: ${({ bgColor }) => (bgColor ? bgColor : '#F1F4F7')};
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ActionButton = ({ bgColor, handleClick, children }) => {
    return (React.createElement(ActionButtonWrapper, { bgColor: bgColor, onClick: handleClick }, children));
};
export const BottomMenuControls = ({ buttonList }) => {
    const windowWidth = window.innerWidth;
    useEffect(() => {
        const localWidget = document.getElementById('localize-widget');
        if (localWidget) {
            localWidget.style.display = 'none';
        }
    }, []);
    return (React.createElement(ControlsWrapper, { width: windowWidth, controlNums: buttonList }, buttonList.map((item) => (React.createElement(ActionButton, { key: item.id, bgColor: item.id === 'cancel-btn' ? '#FB2F2F' : '', handleClick: item.onClick }, item.icon)))));
};
//# sourceMappingURL=bottom_menu_edit.js.map